/* eslint-disable indent, space-before-function-paren, no-console */
import { Widget } from "blue-widgets";
import * as validation from "../tools/validation";

class PaymentFormHandler extends Widget {
  constructor(el) {
    super(el);
    this.inputs = this.el.querySelectorAll(
      "input[type='text'], input[type='radio'], input[type='email'], input[type='password'], input[type='number'], input[type='tel'], input[type='url'], textarea, input[type='checkbox'], select"
    );
    this.currencyInputs = this.el.querySelectorAll(".input-number--currency");
    this.payerDetails = document.getElementById("payer-details");
    this.studentFirstname = document.getElementById("student-first-name");
    this.studentLastname = document.getElementById("student-last-name");
    this.payerFirstname = document.getElementById("account-first-name");
    this.payerLastname = document.getElementById("account-last-name");
    this.serverErrorElm = this.el.querySelector("[data-server-error]");
    this.submit = this.el.querySelector("[type = 'submit']");

    this.hasErrors = false;
    this.handleInput = this.handleInput.bind(this);
    this.init();
  }

  init() {
    this.payerDetails.addEventListener(
      "change",
      this.payerToggleDetailsHandler
    );
    this.submit.addEventListener("click", (e) => {
      e.preventDefault();
      this.submitHandler();
    });
    if (this.inputs) {
      this.inputs.forEach((input) => {
        input.addEventListener("change", (e) => this.handleInput(e));
      });
    }
    if (this.currencyInputs) {
      this.currencyInputs.forEach((input) => {
        input.addEventListener("change", (e) => this.currencyInputHandler(e));
      });
    }
  }

  handleInput = (e) => {
    if (!this.hasErrors) {
      return;
    }
    const { target } = e;
    this.validationHandler(target);
  };

  currencyInputHandler = (e) => {
    const { target } = e;
    const { value } = target;
    const splitArray = value.split(".");

    if (splitArray.length > 1) {
      const integerPart = splitArray[0];
      let decimalPart = splitArray[1].substring(0, 2);
      if (decimalPart.length === 1) {
        decimalPart += "0";
      }
      const trimmedValue = integerPart + (decimalPart ? "." + decimalPart : "");
      target.value = trimmedValue;
    } else {
      target.value = value + ".00";
    }
  };

  toggleErrorStateHandler = (hasError, elm) => {
    const isSelect = elm.nodeName.toLowerCase() === "select";
    const parentElem = isSelect ? elm.closest(".select") : elm.parentElement;
    const inputElem = isSelect
      ? elm.closest(".select").querySelector(".select__input-trigger")
      : elm;

    if (parentElem) {
      if (hasError) {
        parentElem.classList.add("has-error");
        inputElem.setAttribute("aria-invalid", "true");
      } else {
        parentElem.classList.remove("has-error");
        inputElem.removeAttribute("aria-invalid");
      }
    }
  };

  setErrorMessageHandler = (hasError, elm, msg) => {
    const isSelect = elm.nodeName.toLowerCase() === "select";
    const parentElem = isSelect ? elm.closest(".select") : elm.parentElement;
    const inputElem = isSelect
      ? elm.closest(".select").querySelector(".select__input-trigger")
      : elm;
    const errorText = parentElem?.querySelector(".input-error");
    if (errorText) {
      if (hasError) {
        const spanId = errorText.getAttribute("id");
        if (spanId) {
          inputElem.setAttribute("aria-describedby", spanId);
        }
      } else {
        inputElem.removeAttribute("aria-describedby");
      }
    }

    if (errorText) {
      const errorSpan = errorText.querySelector("span");
      if (errorSpan) {
        errorSpan.innerHTML = msg;
      }
    }
  };

  validationHandler = (input) => {
    const { value, type, checked } = input;
    const isRequired = input.hasAttribute("required");
    const isDisabled = input.hasAttribute("disabled");
    const isEmailConfirmField = input.hasAttribute("data-should-match");

    if (isRequired && !isDisabled) {
      if (!validation.hasValue(value, type, checked)) {
        this.toggleErrorStateHandler(true, input);
        this.setErrorMessageHandler(true, input, "This is a required field");
        this.hasErrors = true;
        return;
      }
      if (type === "email" && !validation.isValidEmail(value)) {
        this.toggleErrorStateHandler(true, input);
        this.setErrorMessageHandler(true, input, "Enter a valid email address");
        this.hasErrors = true;
        return;
      }
    }

    if (isEmailConfirmField) {
      const inputIdToMatch = input.getAttribute("data-should-match");
      const emailInput = document.getElementById(inputIdToMatch);
      if (emailInput) {
        const valueOne = emailInput.value.replace(/\s/g, "");
        const valueTwo = input.value.replace(/\s/g, "");
        if (valueOne !== valueTwo) {
          this.toggleErrorStateHandler(true, input);
          this.setErrorMessageHandler(true, input, "Emails do not match");
          this.hasErrors = true;
          return;
        }
      }
    }

    this.toggleErrorStateHandler(false, input);
    this.setErrorMessageHandler(false, input, "");
  };

  mirrorInputHandler = (e) => {
    const inputId = e.target.getAttribute("id");
    const targetInputId = inputId.split("-");
    if (targetInputId.length > 0) {
      targetInputId[0] = "account";
    }
    const resultString = targetInputId.join("-");
    if (resultString.length > 0) {
      document.getElementById(resultString).value = e.target.value;
    }
  };

  payerToggleDetailsHandler = (e) => {
    const isChecked = e.target.checked;

    const setFields = (payerField, studentField) => {
      if (payerField && studentField) {
        payerField.value = studentField.value;
        payerField.setAttribute("disabled", "");
        studentField.addEventListener("change", this.mirrorInputHandler, false);
      }
    };

    const clearFields = (payerField, studentField) => {
      if (payerField) {
        payerField.removeAttribute("disabled");
        studentField.removeEventListener(
          "change",
          this.mirrorInputHandler,
          false
        );
      }
    };

    if (isChecked) {
      setFields(this.payerFirstname, this.studentFirstname);
      setFields(this.payerLastname, this.studentLastname);
      if (this.hasErrors) {
        this.validationHandler(this.payerFirstname);
        this.validationHandler(this.payerLastname);
      }
    }

    if (!isChecked) {
      clearFields(this.payerFirstname, this.studentFirstname);
      clearFields(this.payerLastname, this.studentLastname);
    }
  };

  focusInvalidInputHandler = () => {
    const firstInvalid = this.el.querySelector("[aria-invalid");
    if (firstInvalid) {
      const isSelect = firstInvalid.nodeName.toLowerCase() === "select";
      const elmToFocus = isSelect
        ? firstInvalid
            .closest(".select")
            .querySelector(".select__input-trigger")
        : firstInvalid;

      elmToFocus.focus();
      // Calculate the final position for scrolling
      const scrollPosition =
        elmToFocus.getBoundingClientRect().top + window.scrollY - 124;

      // Scroll to the target element with the offset
      window.scrollTo({ top: scrollPosition, behavior: "smooth" });
    }
  };

  submitHandler = () => {
    this.submit.setAttribute("disabled", "");
    if (this.inputs) {
      this.hasErrors = false;
      this.inputs.forEach((input) => {
        this.validationHandler(input);
      });
    }
    if (this.hasErrors) {
      this.focusInvalidInputHandler();
    }
    if (!this.hasErrors) {
      const tokenElement = document.querySelector(
        "input[name='__RequestVerificationToken']"
      );
      const token = tokenElement.value;

      const requestBody = {};

      this.inputs.forEach((input) => {
        if (input.type === "radio" && !input.checked) return;
        requestBody[input.name] = input.value;
      });

      fetch("/umbraco/Surface/CardPayment/Proceed", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          RequestVerificationToken: token
        },
        body: JSON.stringify(requestBody)
      })
        .then(async (response) => {
          if (response.ok) {
            const jsonResponse = await response.json();
            this.serverErrorElm.classList.add("d-none");
            window.location.replace(jsonResponse.redirectUrl);
          } else {
            console.error(
              "Error sending POST request. Status:",
              response.status
            );
            this.serverErrorElm.classList.remove("d-none");
          }
        })
        .catch((error) => {
          console.error("Error sending POST request:", error);
          this.serverErrorElm.classList.remove("d-none");
        });
    }
    this.submit.removeAttribute("disabled");
  };

  beforeRemove() {
    this.payerDetails.removeEventListener(
      "change",
      this.payerToggleDetailsHandler
    );
    this.submit.removeEventListener("click", this.submitHandler);

    if (this.inputs) {
      this.inputs.forEach((input) => {
        input.removeEventListener("change", (e) => this.handleInput(e));
      });
    }

    if (this.currencyInputs) {
      this.currencyInputs.forEach((input) => {
        input.removeEventListener("blur", (e) => this.currencyInputHandler(e));
      });
    }
  }
}

export default PaymentFormHandler;
